'use client';

import { c as _c } from "react/compiler-runtime";
import { SUBSCRIPTION, type Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H2 } from '@algoacademy/design-system/web/marketing/typography/Heading/H2';
import { P3 } from '@algoacademy/design-system/web/marketing/typography/Paragraph/P3';
import { useState } from 'react';
import { MENTORING_TABS, MentoringTabs } from './_components/MentoringTabs';
import { PricingCard } from './_components/PricingCard';
import { SubscriptionTabs } from './_components/SubscriptionTabs';
import { AdvancedMentoring } from './Mentoring/AdvancedMentoring';
import { BasicMentoring } from './Mentoring/BasicMentoring';
import { useMentoringProducts } from './Mentoring/useMentoringProducts';
export function MentoringPricing() {
  const $ = _c(26);
  const [activeSubscriptionTab, setActiveSubscriptionTab] = useState(SUBSCRIPTION.PER_4_WEEKS);
  const [activeMentoringTab, setActiveMentoringTab] = useState(MENTORING_TABS.ADVANCED_MENTORING);
  const {
    advancedProduct,
    setAdvancedProduct,
    basicProduct
  } = useMentoringProducts(activeSubscriptionTab);
  const currentProduct = activeMentoringTab === MENTORING_TABS.ADVANCED_MENTORING ? advancedProduct : basicProduct;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <H2>Wybierz mentoring idealny dla Ciebie</H2>;
    t1 = <VerticalSpacer size="content" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.values(MENTORING_TABS);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activeMentoringTab) {
    t3 = <section className="flex flex-col items-center text-center">{t0}{t1}<MentoringTabs tabs={t2 as MENTORING_TABS[]} activeTab={activeMentoringTab} setActiveTab={setActiveMentoringTab} /></section>;
    $[3] = activeMentoringTab;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <VerticalSpacer size="content" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== activeMentoringTab || $[7] !== activeSubscriptionTab || $[8] !== advancedProduct || $[9] !== setAdvancedProduct) {
    t5 = <div className="w-full">{activeMentoringTab === MENTORING_TABS.ADVANCED_MENTORING ? <AdvancedMentoring activeSubscriptionTab={activeSubscriptionTab} advancedMentoringProduct={advancedProduct} setAdvancedMentoringProduct={setAdvancedProduct} /> : <BasicMentoring />}</div>;
    $[6] = activeMentoringTab;
    $[7] = activeSubscriptionTab;
    $[8] = advancedProduct;
    $[9] = setAdvancedProduct;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <P3 className="text-slate-600">Typ subskrypcji</P3>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = Object.values(SUBSCRIPTION);
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== activeSubscriptionTab) {
    t8 = <section className="space-y-2 text-center">{t6}<SubscriptionTabs tabs={t7 as Subscription[]} activeTab={activeSubscriptionTab} setActiveTab={setActiveSubscriptionTab} /></section>;
    $[13] = activeSubscriptionTab;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== currentProduct) {
    t9 = <PricingCard mentoringProduct={currentProduct} />;
    $[15] = currentProduct;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <LightCard className="top-8 right-0 block w-full shrink-0 rounded-lg lg:sticky lg:w-sm"><div className="flex flex-col items-center gap-8">{t8}{t9}</div></LightCard>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = <div className="relative flex flex-col justify-between gap-8 lg:flex-row">{t5}{t10}</div>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t3) {
    t12 = <section id="wybierz-mentoring-idealny-dla-ciebie">{t3}{t4}{t11}</section>;
    $[23] = t11;
    $[24] = t3;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}